import style from './PickupPage.css';
import AppBar from '../../components/shared/AppBar/AppBar';
import ListingSkeleton from '../../components/shared/ListingSkeleton/ListingSkeleton';
import PickupView from './PickupView';
import { useEffect, useRef, useState } from 'preact/hooks';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import NavigationUtils from '../../utils/navigation.utils';
import CardService from '../../services/card.service';

const handleBackClick = () => {
  NavigationUtils.back();
};
export default function PickupPage({
  popup,
  organization: organizationCode,
  type,
}) {
  const [loading, setLoading] = useState(true);
  const [ownPickups, setOwnPickups] = useState(false);
  const backRef = useRef(null);

  useAndroidBackPress(backRef.current, () => {
    if (window.location.search.includes('popup')) {
      history.back();
    } else {
      backRef.current.props.onClick();
    }
  });

  useEffect(() => {
    CardService.get(organizationCode)
      .then(response => {
        const cards = response.data || [];

        setOwnPickups(cards[0]?.ownPickups || false);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <AppBar
        onBackClick={handleBackClick}
        className="fixed-bar"
        backRef={backRef}
      />

      <div className={style.container}>
        {loading ? (
          <ListingSkeleton className={style.main} />
        ) : (
          <PickupView
            ownPickups={ownPickups}
            showPopup={!!popup}
            organizationCode={organizationCode}
            type={type}
          />
        )}
      </div>
    </>
  );
}
